import avatar from '../../assets/images/avatar.svg'
import {
  AvatarStyles,
  CardTourStyles,
  CardTourWithAvatarStyles,
} from './styles'

const TourPredicoes = [
  {
    title: <AvatarStyles src={avatar} alt="avatar" />,
    content: (
      <CardTourWithAvatarStyles marginTop="40px">
        <span>Dúvidas sobre as predições de vendas?</span>
        <br />
        <br />
        <strong> Vamos lá!</strong>
      </CardTourWithAvatarStyles>
    ),
    target: '#saudacaoPredicao',
    placement: 'center',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p>Previsão da próxima compra</p>
        <span>
          Nesta tela você acompanha quais materiais estão próximos de se esgotar
          no estoque do cliente e qual a melhor data para a próxima compra.
        </span>
      </CardTourStyles>
    ),
    target: '#cardPredicaoProduto',
    placement: 'right-fixed',
  },
  {
    content: (
      <CardTourStyles marginTop="-20px">
        <p>Previsão da próxima compra</p>
        <span>
          Clicando sobre o cliente é possivel analisar a quantidade dos
          materiais que ele necessita, outros produtos comprados com frequência
          e ainda realizar a baixa dos materiais já ofertados.
        </span>
      </CardTourStyles>
    ),
    target: '#cardPredicaoCliente',
    placement: 'right-fixed',
  },
]
export default TourPredicoes
